import {useServerPagination, type UseServerPaginationResult} from '@/shared/hooks/useServerPagination';
import {api} from '@/shared/services/api-client';
import {queryKeys} from '@/lib/query-keys';
import type {HistoryEntry} from '@/shared/types/history';

/**
 * Fetch one page of a session type's change-log (OD-892 "History" tab).
 * The endpoint already returns entries newest-first.
 */
async function fetchSessionTypeHistoryPage(
  sessionTypeId: string,
  req: {page: number; limit: number},
): Promise<{rows: HistoryEntry[]; total: number; pages: number}> {
  const res = await api.sessionTypes.getHistory(sessionTypeId, req.page, req.limit);
  const body = res?.data ?? {};
  return {
    rows: Array.isArray(body.data) ? (body.data as HistoryEntry[]) : [],
    total: body.count ?? 0,
    pages: body.totalPages ?? 1,
  };
}

export function useSessionTypeHistoryQuery(
  sessionTypeId?: string | null,
  pageSize = 10,
): UseServerPaginationResult<HistoryEntry> {
  return useServerPagination<HistoryEntry>({
    queryKey: queryKeys.history.forSessionType(String(sessionTypeId ?? '')),
    fetchPage: (req) => fetchSessionTypeHistoryPage(String(sessionTypeId), req),
    pageSize,
    enabled: Boolean(sessionTypeId),
  });
}
